export const BaseRoute = process.env.BASE_ROUTE;

export const DDSSORoute = '/sso';
export const WWSSORoute = '/sso_wecom';
export const KWSSORoute = '/sso_kaixue';
export const LYSSORoute = '/sso_lingyang';
